<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="https://intelliprice.io" target="_blank" rel="nofollow">Intelliprice</a>
          <span class="hidden sm:inline-block">, All rights Reserved</span>
        </p>
        <span class="md:flex hidden items-center">
            <router-link to="/support">Υποστήριξη</router-link>
        </span>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
}
</script>
